<template>
  <span class="copy-button" data-inverted :data-tooltip="newTooltip" @click.stop.prevent="copy()">
    <i class="copy outline fitted icon" />
  </span>
</template>

<script>
  export default {
    name: 'CopyIcon',
    props: {
      value: {
        type: String,
        required: true,
      },
      tooltip: {
        type: String,
        required: false,
        default: 'Copy',
      },
    },
    data() {
      return {
        newTooltip: this.tooltip,
      }
    },
    methods: {
      copy() {
        this.$copyText(this.value).then(() => {
          this.newTooltip = 'Copied!'
        }, () => {
          this.newTooltip = 'Can\'t copy!'
        })
        setTimeout(() => {
          this.newTooltip = this.tooltip
        }, 1000)
      },
    },
  }
</script>

<style scoped>
  .copy { opacity: .6!important; }
  .copy:hover { opacity: 1!important; }
</style>
